// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"Documentation_headerWrapper__xln_n","card":"Documentation_card__1TWtt","cardHeader":"Documentation_cardHeader__xv_vO"};